import React, { useContext } from "react";
import { DateTime } from "luxon";
import { ResultsEventContext } from "@state/context/results";
import ResultsEventData from "./ResultsEventData";

export default function ResultsEvent() {
	const event = useContext(ResultsEventContext);

	return (
		<tr className="table--results__body__row">
			<td className="table--results__body__data table--results__body__data--time">
				{DateTime.fromISO(event.startTime).toFormat("T")}
			</td>
			<td className="table--results__body__data table--results__body__data--teams">
				<div>{event.teamOne}</div>
				<div>{event.teamTwo}</div>
			</td>

			<ResultsEventData />
		</tr>
	);
}
